import { useEffect, useState } from "react";
import { Button, Skeleton, Row, Col } from 'antd';
import { EmployeeWithProfile } from "@comps/components"
import { convertTimeTotz } from '@comps/commonFunctions'
import "./Roster.css"

const moment = require('moment')

const RoasterView = (props) => {

  // ================== STATE ==================
  const [employments] = useState(props.record.employments);
  const [dateTotalSource, setDateTotalSource] = useState([]);
  const [excludedShiftIds, setExcludedShiftIds] = useState([]);
  const [allShiftIds, setAllShiftIds] = useState([]);
  const preSelected = props.preSelected || [];
  // ================== EFFECT ==================
  useEffect(() => {
    generateCalender()
    if (props.record?.shifts) {

      const ids = Object.values(props.record.shifts)
        .flat()
        .map(shift => shift.id);

      setAllShiftIds(ids);
      // add to excluded 

      if (preSelected.length > 0) {
        setExcludedShiftIds(ids.filter(id => !preSelected.includes(id)));
      }
    }
    // eslint-disable-next-line
  }, [props.record]);



  // ================== CALENDAR ==================
  const generateCalender = () => {
    let start = moment(new Date(props.record.from_date))
    let end = moment(new Date(props.record.to_date))
    let date_total = [];

    while (start <= end) {
      date_total.push(start.format('YYYYMMDD'));
      start = start.add(1, 'days');
    }

    setDateTotalSource(date_total)
  }

  // ================== CLICK HANDLER ==================
  const onClickShiftTime = (shiftId) => {
    if (!shiftId) return;

    let updatedExcluded;

    if (excludedShiftIds.includes(shiftId)) {
      // remove from excluded → selected
      updatedExcluded = excludedShiftIds.filter(id => id !== shiftId);
    } else {
      // add to excluded → unselected
      updatedExcluded = [...excludedShiftIds, shiftId];
    }

    setExcludedShiftIds(updatedExcluded);

    // ✅ Selected = all - excluded
    const selectedShiftIds = allShiftIds.filter(
      id => !updatedExcluded.includes(id)
    );

    if (props.addToSelectedShifts) {
      props.addToSelectedShifts(selectedShiftIds);
    }



  };
  // ================== UI ==================
  return (
    <div style={ { marginBottom: 30 } }>
      <Skeleton loading={ false }>
        <Row>

          {/* LEFT SIDE (EMPLOYEES) */ }
          <Col span={ 6 }>
            <table border={ 1 } className="table">
              <thead>
                <tr>
                  <th style={ { padding: 14 } }>
                    <span className="Employee-Name">Employee</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                { employments.map((employee) => (
                  <tr key={ employee.id }>
                    <td style={ { width: 250 } }>
                      <EmployeeWithProfile record={ employee } />
                    </td>
                  </tr>
                )) }
              </tbody>
            </table>
          </Col>

          {/* RIGHT SIDE (ROSTER GRID) */ }
          <Col span={ 18 } style={ { overflowX: "scroll" } }>
            <table border={ 1 } className="table">

              {/* HEADER */ }
              <thead>
                <tr>
                  { dateTotalSource.map((date) => (
                    <th key={ date } style={ { padding: 14 } }>
                      <div style={ { marginLeft: 40, color: "#4079FC" } }>
                        <span>
                          { convertTimeTotz(date).format('dddd').substring(0, 10) }
                        </span>
                        <span>
                          { "-" + convertTimeTotz(date).format('DD') }
                        </span>
                      </div>
                    </th>
                  )) }
                </tr>
              </thead>

              {/* BODY */ }
              <tbody>
                { employments.map((employee) => (
                  <tr key={ employee.id }>

                    { dateTotalSource.map((date) => {

                      const dateKey = date + '-' + employee.id;

                      const shiftId = props.record.shifts.hasOwnProperty(dateKey)
                        ? props.record.shifts[dateKey][0]['id']
                        : null;

                      const isSelected = shiftId ? !excludedShiftIds.includes(shiftId) : false;

                      const shiftData = props.record.shifts[dateKey]?.[0];

                      return (
                        <td key={ dateKey } style={ { border: '1px solid #C9D6DF' } }>
                          <div style={ {
                            height: 76,
                            width: 200,
                            paddingLeft: 20
                          } }>
                            <div style={ { textAlign: 'center' } }>

                              <Button
                                disabled={ props.addToSelectedShifts ? false : true }
                                onClick={ () => onClickShiftTime(shiftId) }
                                className="roster-time-button"
                                style={ {
                                  backgroundColor: isSelected ? '#4079FC' : 'white',
                                  color: isSelected ? '#fff' : '#000',
                                  border: isSelected
                                    ? '2px solid #305fd1'
                                    : '1px solid #C9D6DF',
                                  marginLeft: 30,
                                  transition: '0.2s'
                                } }
                              >

                                { shiftData ? (
                                  <span style={ {
                                    padding: '2px',
                                    marginLeft: -10,
                                    backgroundColor: isSelected
                                      ? '#fff'
                                      : shiftData.bg_colour,
                                    color: isSelected
                                      ? '#4079FC'
                                      : shiftData.font_colour
                                  } }>
                                    { convertTimeTotz(shiftData.start).format('hh:mm A') } -
                                    { convertTimeTotz(shiftData.end).format('hh:mm A') }
                                  </span>
                                ) : (
                                  <span style={ { color: "#EA4335" } }>
                                    Day Off
                                  </span>
                                ) }

                                {/* ✔ indicator */ }
                                { isSelected && (
                                  <span style={ { marginLeft: 5 } }>✔</span>
                                ) }

                              </Button>

                            </div>
                          </div>
                        </td>
                      );
                    }) }

                  </tr>
                )) }
              </tbody>

            </table>
          </Col>

        </Row>
      </Skeleton>
    </div>
  )
}

export default RoasterView